export default __webpack_public_path__ + "static/media/fzlc.8a514914.png";